import React from "react";
import { Button, List, Space, Typography } from "antd";
import { BatchJob } from "reducers/types";

interface Props {
  jobs: BatchJob[];
  renderLabel: (job: BatchJob) => React.ReactNode;
  onCancel: (jobId: string) => void;
  onSelect?: (jobId: string) => void;
}

// Compact list of the other active jobs of a type (U18). Not a history table (U11).
const JobQueueList: React.FC<Props> = ({ jobs, renderLabel, onCancel, onSelect }) => {
  if (jobs.length === 0) {
    return null;
  }
  return (
    <List
      size="small"
      header={<Typography.Text type="secondary">Queued</Typography.Text>}
      dataSource={jobs}
      renderItem={(job) => (
        <List.Item
          actions={[
            <Button key="cancel" size="small" danger onClick={() => onCancel(job.jobId)}>
              Cancel
            </Button>,
          ]}
        >
          <Space>
            {onSelect ? (
              <Typography.Link onClick={() => onSelect(job.jobId)}>{renderLabel(job)}</Typography.Link>
            ) : (
              renderLabel(job)
            )}
            {job.queuePosition ? <Typography.Text type="secondary">#{job.queuePosition}</Typography.Text> : null}
          </Space>
        </List.Item>
      )}
    />
  );
};

export default JobQueueList;
